<div class="participant-container content-card mat-white-bg">
  <div class="pc-title">{{'learning_paths.participants' | translate}}</div>
  <div>
    <mat-button-toggle-group #group="matButtonToggleGroup" class="communication-action"
                             [value]="selectedVal"
                             [disabled]="!checkedUsers.length"
                             (change)="communicationAction($event)">
      <mat-button-toggle value="mail" [disabled]="!checkedUsers.length" matTooltip="{{'learning_paths.email' | translate}}">
        <mat-icon>email</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle value="serial" [disabled]="!checkedUsers.length" matTooltip="{{'learning_paths.serialLetter' | translate}}">
        <mat-icon>receipt</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle value="emailList" [disabled]="!checkedUsers.length" matTooltip="{{'learning_paths.emailList' | translate}}">
        <mat-icon>forward_to_inbox</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle value="hide" [hidden]="true">
        <mat-icon>hide</mat-icon>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <mat-table class="products-table"
             #table [dataSource]="participants"
             matSort
             [@animateStagger]="{value:'50'}"
             fusePerfectScrollbar>

    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef style="flex: 0 0 50px;">
        <mat-checkbox (change)="$event ? masterToggle() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()">
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let row" style="flex: 0 0 50px;">
        <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="$event ? selection.toggle(row) : null; checkUser(row, $event)"
                      [checked]="selection.isSelected(row)">
        </mat-checkbox>
      </mat-cell>
    </ng-container>


    <!-- Name Column -->
    <ng-container cdkColumnDef="name">
      <mat-header-cell *cdkHeaderCellDef >{{'canton.name' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        <p class="text-truncate">{{user?.frontUser?.lastName}} {{user?.frontUser?.firstName}}</p>
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="organization">
      <mat-header-cell *cdkHeaderCellDef >{{'user.organization' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        <p class="text-truncate">{{user?.frontUser?.organization?.name}}</p>
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="event">
      <mat-header-cell *cdkHeaderCellDef >{{'main.events' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user" [class.completed]="+user?.eventParticipantIds?.length === +hasEvent">
        <p class="text-truncate">{{user?.eventParticipantIds?.length}} / {{hasEvent}}</p>
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="elearning">
      <mat-header-cell *cdkHeaderCellDef >{{'main.eLearning' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user" [class.completed]="+user?.elearningParticipantIds?.length === +hasElearning">
        <p class="text-truncate">{{user?.elearningParticipantIds?.length}} / {{hasElearning}}</p>
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="createdAt">
      <mat-header-cell *cdkHeaderCellDef >{{'created_at' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        <p class="text-truncate">{{user?.createdAt | date: 'EEE, d. MMMM HH:mm'}}</p>
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="targetGroup">
      <mat-header-cell *cdkHeaderCellDef >{{'user.targetGroup' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        <p class="text-truncate">{{user?.frontUser?.targetGroup?.ageMask}}</p>
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="deleteFromParticipant">
      <mat-header-cell *cdkHeaderCellDef class="delete-container"></mat-header-cell>
      <mat-cell *cdkCellDef="let user" class="delete-container">
        <i matTooltip="{{'learning_paths.removeFromParticipant' | translate}}" (click)="deleteFromParticipant($event, user)" class="material-icons"
           style="cursor: pointer">
          backspace
        </i>
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="rewards">
      <mat-header-cell *cdkHeaderCellDef class="delete-container"></mat-header-cell>
        <mat-cell *cdkCellDef="let user" class="delete-container">
          @if (+user?.elearningParticipantIds?.length === +hasElearning && +user?.eventParticipantIds?.length === +hasEvent) {
            <i [matTooltip]="!user?.alreadyRewarded ? ('learning_paths.giveRewards' | translate) : ('learning_paths.alreadyRewarded' | translate)"
               (click)="rewardsParticipant(user)"
               [class.alreadyRewarded]="user?.alreadyRewarded"
               class="material-icons gold"
               style="cursor: pointer">
              workspace_premium
            </i>
          }
        </mat-cell>

    </ng-container>

    <ng-container cdkColumnDef="skills">
      <mat-header-cell *cdkHeaderCellDef class="delete-container"></mat-header-cell>
        <mat-cell *cdkCellDef="let user" class="delete-container">
          @if (+user?.elearningParticipantIds?.length === +hasElearning && +user?.eventParticipantIds?.length === +hasEvent) {
            <i [matTooltip]="!user?.alreadySkilled ? ('learning_paths.giveSkills' | translate) : ('learning_paths.alreadySkilled' | translate)"
               (click)="skillParticipant(user)"
               [class.alreadyRewarded]="user?.alreadySkilled"
               class="material-icons gold"
               style="cursor: pointer">
              psychology
            </i>
          }
        </mat-cell>

    </ng-container>


    <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

    <mat-row *cdkRowDef="let user; columns: displayedColumns;"
             (click)="openDialog(user)"
             class="product"
             matRipple>
    </mat-row>

  </mat-table>
</div>
